/**
 * ¿Hay un deploy del front más nuevo que el que corre en esta pestaña?
 *
 * No hace falta archivo de versión: cada build cambia el hash de `app.<hash>.js`, y
 * `index.html` es lo único del sitio que se sirve sin caché. Se compara el script
 * con el que arrancó esta pestaña contra el que referencia el `index.html` publicado.
 */

const APP_SCRIPT_RE = /\/assets\/js\/app\.([0-9a-f]+)\.js/;
const CHECK_EVERY_MS = 5 * 60 * 1000;
const MIN_GAP_MS = 60 * 1000;

let runningHash = null;
let newBuildAvailable = false;
let lastCheckAt = 0;
let inflight = null;

function hashFromDocument() {
  const scripts = document.querySelectorAll("script[src]");
  for (const s of scripts) {
    const m = String(s.getAttribute("src") || "").match(APP_SCRIPT_RE);
    if (m) return m[1];
  }
  return null;
}

async function checkNow() {
  if (!runningHash || newBuildAvailable || inflight) return;
  const now = Date.now();
  if (now - lastCheckAt < MIN_GAP_MS) return;
  lastCheckAt = now;
  // `reload` y no `no-store`: además de traer el index fresco, pisa el que haya en la
  // caché HTTP, así la recarga que sigue no vuelve a abrir el build viejo.
  inflight = fetch("/index.html", { cache: "reload", credentials: "omit" })
    .then((res) => (res.ok ? res.text() : ""))
    .then((html) => {
      const m = html.match(APP_SCRIPT_RE);
      if (m && m[1] !== runningHash) newBuildAvailable = true;
    })
    .catch(() => {})
    .finally(() => {
      inflight = null;
    });
  await inflight;
}

/** Solo en el build de producción: en dev el script no lleva hash. */
export function startNewBuildCheck() {
  if (typeof window === "undefined" || process.env.NODE_ENV !== "production") return;
  runningHash = hashFromDocument();
  if (!runningHash) return;
  setInterval(checkNow, CHECK_EVERY_MS);
  // Quien vuelve a una pestaña que quedó abierta desde antes del deploy es el caso típico.
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") checkNow();
  });
  window.addEventListener("focus", checkNow);
}

export function isNewBuildAvailable() {
  return newBuildAvailable;
}
